import { PhoneNumber, ResourceType } from "../global/types"

export enum Grade {
  Band1 = "band_1",
  Band2 = "band_2",
  Band3 = "band_3",
  Band4 = "band_4",
  Band5 = "band_5",
}

export enum Status {
  Active = "active",
  Inactive = "inactive",
  Invited = "invited",
}

export type BaseUser = {
  id: number
  userId: string
  dateCreated: string
  teachingLevels: Array<{
    name: string
    uuid?: string | null
  }>
  name: string
  lastOnlineAt?: string | null
}

export type Analytics = {
  attempt: {
    band: Grade | null
  }
  plannerAnalytics: {
    averageProgress?: number
  } | null
  masterclass: {
    total: number
    attended: number
  }
  totalLearningMinutes: number
}

export type OrganizationUser = BaseUser & {
  status: Status.Active | Status.Inactive
  picture: string | null
  lastOnlineAt?: string | null
  analytics?: Analytics
  // TODO: remove the optional operator once the mockData is removed
  email?: string
}

export type OrganizationInvitedUser = BaseUser & {
  userId: null
  status: Status.Invited
  picture: null
  lastOnlineAt?: null
  analytics?: null
}

export type OrganizationUserType = OrganizationUser | OrganizationInvitedUser

export type NamedEntity = {
  name: string
  uuid?: string | null
}

export type UserData = {
  userId: string
  status: Status
  dateCreated: string
  designation?: string | null
  subjectsTaught?: NamedEntity[]
  gradesTaught?: string[]
  curricula?: NamedEntity[]
  teachingLevels: NamedEntity[]
  department?: string | null
  name: string
  lastOnlineAt?: string | null
  picture?: string | null
  email?: string
  phoneNumber?: PhoneNumber
}

export type InvitedUserData = {
  id: number
  name: string
  email: string
  phoneNumber: string | null
  designation: string | null
  subjectsTaught: NamedEntity[]
  gradesTaught: string[]
  curricula: NamedEntity[]
  teachingLevels: NamedEntity[]
  department: string | null
  dateExpires: string
}
export type AddTeacherResponseType = {
  id: number
  name: string
  email: string
  phoneNumber: string | null
  designation: string | null
  subjectsTaught: ResourceType[]
  gradesTaught: string[]
  curricula: ResourceType[]
  teachingLevels: ResourceType[]
  department: string | null
  dateAccepted: string | null
  dateExpires: string
  isActive: boolean
  organization: number
}
